module.exports = __webpack_public_path__ + "img/stop-btn-fill.6bb8dcd1.svg";